import type { QuantityRule, RangeRule } from '@/lib/supplies';

/**
 * The kit rule math, the same as the API's
 * `apps/api/src/lib/supplies/packing-list.ts`, so a sandbox rebuild gives
 * the numbers a real one would.
 */

export interface Headcount {
  readonly participants?: number;
  readonly teams?: number;
}

export function quantityFor(rule: QuantityRule, headcount: Headcount): { quantity: number; needsHeadcount: boolean } {
  let quantity = rule.fixed ?? 0;
  let needsHeadcount = false;
  if (rule.perTeam) {
    if (headcount.teams === undefined) needsHeadcount = true;
    else quantity += rule.perTeam * headcount.teams;
  }
  if (rule.perParticipant) {
    if (headcount.participants === undefined) needsHeadcount = true;
    else quantity += rule.perParticipant * headcount.participants;
  }
  if (rule.perGroup && rule.perGroup.participants > 0) {
    if (headcount.participants === undefined) needsHeadcount = true;
    else quantity += rule.perGroup.quantity * Math.ceil(headcount.participants / rule.perGroup.participants);
  }
  if (rule.ranges && rule.ranges.length > 0) {
    if (headcount.participants === undefined) needsHeadcount = true;
    else quantity += rangeQuantity(rule.ranges, headcount.participants);
  }
  return { quantity: Math.ceil(quantity), needsHeadcount };
}

export function rangeQuantity(ranges: readonly RangeRule[], participants: number): number {
  const capped = ranges.filter((band): band is RangeRule & { upTo: number } => band.upTo !== undefined).sort((a, b) => a.upTo - b.upTo);
  const open = ranges.find((band) => band.upTo === undefined);
  const hit = capped.find((band) => participants <= band.upTo);
  if (hit) return hit.quantity;
  if (open) return open.quantity;
  return capped.at(-1)?.quantity ?? 0;
}
